import React from 'react';
import PropTypes from 'prop-types';
import { fromJS, List } from 'immutable';
import { useDispatch } from 'react-redux';
import CardFace from '../Card/CardFace';
import { PlainButton } from '../Controls';
import { viewCard } from '../Card/actions';
import { Grid, GridItem } from './styled';

/**
 * Piles hold plain cards (a discard pile) or things that carry a card (an energy attachment). Either way each entry
 * becomes a card, keeping the id that identifies this copy as pivot_id.
 */
export const normalizeCardsOrCardables = (cardsOrCardables) => cardsOrCardables
  .map(cardOrCardable => {
    const card = cardOrCardable.get('card') || cardOrCardable;
    return fromJS({
      ...card.toObject(),
      pivot_id: card.get('pivot_id') || cardOrCardable.get('id'),
    });
  })
  .sort((a, b) => a.get('order') - b.get('order'));

/** A grid of cards. Tapping one shows it full size; `getSelectButton` adds a control under each. */
const Pile = ({ cardsOrCardables, getDim, getSelectButton, newestFirst }) => {
  const dispatch = useDispatch();
  const inOrder = normalizeCardsOrCardables(cardsOrCardables);
  const cards = newestFirst ? inOrder.reverse() : inOrder;

  return (
    <Grid>
      {cards.map((card) => (
        <GridItem key={card.get('pivot_id')}>
          <PlainButton onClick={() => dispatch(viewCard(card))} aria-label={card.get('name')}>
            <CardFace card={card} dim={getDim && getDim(card)} />
          </PlainButton>
          {getSelectButton && getSelectButton(card)}
        </GridItem>
      ))}
    </Grid>
  );
};

Pile.propTypes = {
  cardsOrCardables: PropTypes.instanceOf(List).isRequired,
  getDim: PropTypes.func,
  getSelectButton: PropTypes.func,
  newestFirst: PropTypes.bool,
};

export default Pile;
